<template>
  <component :is="tag" v-if="!isHtmlContent" :class="contentContainerClass" class="nc-text" :style="customStyle">
    {{ text }}
  </component>
  <div v-else-if="isHtmlContent" :class="contentContainerClass" class="nc-text" v-html="html" :style="customStyle" />
</template>

<script lang="ts">
import { mapState } from 'pinia';
import type { PropType } from 'vue';
import { useWebsiteStore } from '~/units/website/store';

type Types = 'normal' | 'input-label' | 'bold' | 'value' | 'small' | 'standard' | 'numscroller';

export default defineNuxtComponent({
  name: 'LibraryText',

  props: {
    tag: {
      description: 'if html is provided, tag cannot be changed as it uses div',
      required: false,
      type: String as PropType<'span' | 'div' | 'p'>,
      default: 'div',
    },
    text: {
      required: false,
      type: [String, Number],
    },

    type: {
      required: false,
      type: String as PropType<Types>,
      default: 'standard',
    },

    html: {
      required: false,
      type: String,
    },

    customStyle: {
      required: false,
      type: String,
    },
  },

  computed: {
    ...mapState(useWebsiteStore, ['theme']),

    isHtmlContent() {
      return !!this.html;
    },

    contentContainerClass() {
      if (this.theme === 'theme2') {
        if (this.type === 'input-label') {
          return 'tw-uppercase tw-my-2 tw-text-[12px] tw-tracking-[2px]';
        } else if (this.type === 'bold') {
          return 'tw-font-[500] tw-text-[14px]';
        } else if (this.type === 'small') {
          return 'tw-font-[500] tw-text-[12px]';
        }
        return 'tw-font-[300] tw-text-[14px]';
      } else if (this.theme === 'theme3') {
        if (this.type === 'input-label') {
          return 'tw-my-2 tw-text-[14px]';
        } else if (this.type === 'bold') {
          return 'font-arial-bold tw-text-[14px]';
        } else if (this.type === 'value') {
          return 'tw-font-[700] tw-text-[24px]';
        } else if (this.type === 'small') {
          return 'tw-font-[500] tw-text-[12px]';
        } else if (this.type === 'standard') {
          return 'font-arial tw-text-[16px]';
        } else if (this.type === 'numscroller') {
          return 'font-plus-jakarta-extrabold tw-text-6xl lg:tw-text-7xl';
        }
        return 'font-arial tw-font-[500] tw-text-[14px]';
      }
      return '';
    },
  },
});
</script>
